module.exports = __webpack_public_path__ + "img/PKOIN-34-35.e1b68439.png";